import { environment } from '@merchant-portal/environments/environment';
import { ReconnectionTimeMode, RxStompConfig } from '@stomp/rx-stomp';

export const myRxStompConfig: RxStompConfig = {
  // Which server?
  brokerURL: environment.stomp.brokerURL,
  connectHeaders: {
    login: environment.stomp.login,
    passcode: environment.stomp.passcode,
  },
  heartbeatIncoming: 0, // Typical value 0 - disabled
  heartbeatOutgoing: 5000, // Typical value 20000 - every 20 seconds

  // Reconnection strategy with exponential backoff
  reconnectDelay: 1000, // Start with 1 second
  maxReconnectDelay: 60000, // Cap at 60 seconds
  reconnectTimeMode: ReconnectionTimeMode.EXPONENTIAL, // Double delay after each failed attempt

  connectionTimeout: 10000, // 10 seconds timeout instead of default 5 seconds
  debug: (): void => {},
};
